<template>
    <div v-if="alert.show" >
        <div v-if="alert.type == 'danger'" id="alert_message" class="notification is-danger" style="height: 64px; margin-bottom: -64px; margin-top: -60px; z-index: 40; position: fixed; text-align: center; width: 100%;">
            {{ alert.message }}    
        </div>
        <div v-else id="alert_message" class="notification is-success" style="height: 64px; margin-bottom: -64px; margin-top: -60px; z-index: 40; position: fixed; text-align: center; width: 100%;">
            {{ alert.message }}    
        </div>
    </div>
</template>
    
    
<script>
export default {
    props: {
        errors: {
            type: [Array, String]
        }
    },
    data() {
        return {
            error_list: [],
            alert: this.$store.state.alert
        };
    },
    watch: {
        errors: function (new_value, _ /* old_value */) { // Cannot use () => {} as 'this' is required
            this.error_list = []; // Important, else the errors persist
            if (new_value) {
                this.error_list = Array.isArray(new_value) ? new_value : [new_value];
            }
        },
    }
}
</script>
    